class LookbookSectionHeader {
  constructor(element) {
    this.element = element
    this.init()
  }

  init() {
    this.registerObserver()
  }

  registerObserver() {
    const options = {
      rootMargin: '0px 0px -50%',
      threshold: 0
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove('lookbook-section-header--hidden')
          entry.target.classList.add('lookbook-section-header__motion')
          this.observer.unobserve(this.element)
        }
      })
    }, options)
    this.observer.observe(this.element)
  }
}

export default {
  selector: '.js-lookbook-section-header',
  Source: LookbookSectionHeader
}
